import React from 'react';
import searchFilter from '../utilities/search-filter';
import Skeleton from './skeleton/skeleton';
import {useClaimDispatch} from './claim';
import useQuery from '../utilities/use-query';
import useClaimStateEx from '../utilities/use-claim-state-ex';
import {useNavigate} from 'react-router-dom';

const ResetOrder = React.memo(() => {
  const {serviceId} = useQuery();
  const navigate = useNavigate();
  const claimDispatch = useClaimDispatch();
  const claimState = useClaimStateEx();
  const value = React.useMemo(() => claimState.find(e => e.serviceId === serviceId), [claimState, serviceId]);
  React.useEffect(() => {
    if (value) {
      claimDispatch({type: 'remove', payload: {id: value.id}});
    }
    navigate(`/${searchFilter(location.search)}`, {replace: true});
  }, [value]);
  return (
    <Skeleton/>
  );
});

export default React.memo(ResetOrder);
